// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/bilancio-conto-analitico?societaId=&anno=&dataDal=&dataAl=',
    requestBody: null,
    response: '{ success: true, data: { anno, dataDal, dataAl, periodDays, yearDays, divisioni, alberoRicavi, alberoCosti, totali } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
